import Vue from 'vue';

import './js/init/vue-plugin-load-script';
import './js/init/bootstrap-vue';

import UniqueId from 'vue-unique-id';

import VueMobileDetection from 'vue-mobile-detection';

import VTooltip from 'v-tooltip';

import VueLazyload from 'vue-lazyload';

import VueMq from 'vue-mq';

import MoneyFormat from 'vue-money-format';

// import VueTheMask from 'vue-the-mask';
// Remplace VueTheMask qui est bogué
import Inputmask from 'inputmask';

import money from 'v-money';

import vueAwesomeCountdown from 'vue-awesome-countdown';

import { ValidationObserver, ValidationProvider } from 'vee-validate';

import './js/validators';

// Bug IdleVue avec "vite" en npm run build
// import IdleVue from 'idle-vue';
import jQuery from 'jquery';

import Resize from 'vue-resize-directive';
import Capitalize from '@/directives/Capitalize';
import RemoveExtraSpaces from '@/directives/RemoveExtraSpaces';

import JelPlugin from '@/plugins/jelPlugin';
import IdleVue from '@/plugins/idle-vue';

import i18n from '@/js/i18n';
import router from '@/router';
import store from '@/store';
import App from '@/App';

import { inMgnl } from '@/helpers/AppHelpers';

import 'virtual:svg-icons-register';

import SvgIcon from '@/helpers/SvgIcon.vue';

Vue.use(UniqueId);
Vue.use(VueMobileDetection);
Vue.use(VTooltip, {
  defaultBoundariesElement: document.body,
});
Vue.use(VueLazyload);
Vue.use(VueMq, {
  breakpoints: {
    xs: 576, // Petit téléphone
    sm: 768, // Téléphone
    md: 992, // Tablette
    lg: 1200, // Laptop
    xl: 1400, // Desktop
    xxl: Infinity, // Écran large
  },
  defaultBreakpoint: 'sm',
});
Vue.use(MoneyFormat, {
  currencyCode: 'CAD',
  subunitValue: true,
  hideSubunits: true,
});
// Vue.use(VueTheMask);
// Remplace VueTheMask
Vue.use(Inputmask);
Vue.use(money, { precision: 4 });
Vue.use(vueAwesomeCountdown, 'vac');
Vue.component('svg-icon', SvgIcon);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.use(JelPlugin);
Vue.directive('capitalize', Capitalize);
Vue.directive('remove-extra-spaces', RemoveExtraSpaces);
Vue.directive('resize', Resize);

// jQuery est utilisé par barreconnect-app.js
Object.assign(window, { $: jQuery, jQuery });

Vue.config.productionTip = process.env.NODE_ENV != 'production';
// TODO: IMPORTANT: Retirer la ligne suivante avant d'aller en PO
Vue.config.devtools = true;

// eslint-disable-next-line import/prefer-default-export
export const bus = new Vue();

// Permettre d'arrêter certains appels json en cas d'inactivité du consommateur
Vue.use(IdleVue, {
  store,
  eventEmitter: bus,
  idleTime:
    process.env.NODE_ENV == 'production' ? process.env.VUE_APP_IDLE_TIMEOUT_SEC * 1000 : 10 * 1000, // 10 sec en DEV
  startAtIdle: false,
});

let arrayLoadInitial = [store.dispatch('routes/initRoutes')];
if (!inMgnl) {
  arrayLoadInitial = arrayLoadInitial.concat([
    Vue.loadScript('/mel/.resources/lq-entete-commun/webresources/js/sdk-privacy.js'),
    // S'assurer que lq-entete-commun est à jour en vérifiant qu'on crée clavardage.js comme ressource dans le gruntfile
    Vue.loadScript('/mel/.resources/lq-entete-commun/webresources/js/clavardage.js'),
    Vue.loadScript('/__ob/mobile_portal/js/libs/geo.min.js'),
    Vue.loadScript('/__ob/ob/js/loginNav.js'),
    Vue.loadScript('/__ob/ob/js/header.js'),
    Vue.loadScript('/mel/.resources/lq-entete-commun/webresources/js/barreportail-app.js?v=210'),
    Vue.loadScript('/mel/.resources/lq-entete-connexion/webresources/js/barreconnect-app.js?v=210'),
  ]);
}

Promise.all(arrayLoadInitial)
  .then(() => {
    new Vue({
      i18n,
      router,
      store,
      provide() {
        return {
          headerJsDisponible: true,
        };
      },
      // TODO: Déterminer si utile pour préserver position du scroll
      methods: {
        afterLeave() {
          this.$root.$emit('triggerScroll');
        },
      },
      render: (h) => h(App),
    }).$mount('#app');
  })
  .catch(() => {
    new Vue({
      i18n,
      router,
      store,
      provide() {
        return {
          headerJsDisponible: false,
        };
      },
      render: (h) => h(App),
    }).$mount('#app');
  });

// Compatibilité avec les messages dans l'entête
window.xlerr = {
  GEO_DENIED: i18n.t('compte.connexion.erreurGeoloc'),
  GENERIC_ERROR: i18n.t('compte.connexion.erreurGeneric'),
};
